import { colors } from "@/theme/colors";
import { IllustrationSvg } from "./IllustrationSvg";
import { Backdrop } from "./shapes";

/**
 * Flat illustration for "You own everything": a key — the handover of code,
 * accounts, and infrastructure, all yours.
 */
export function OwnershipIllustration() {
  return (
    <IllustrationSvg>
      {/* Soft backdrop */}
      <Backdrop x={44} y={22} width={132} height={94} fill={colors.paper} />
      {/* Key bow (ring) */}
      <circle
        cx="86"
        cy="65"
        r="22"
        fill="none"
        stroke={colors.primary}
        strokeWidth="9"
      />
      {/* Hole through the bow */}
      <circle cx="86" cy="65" r="7" fill={colors.paper} />
      {/* Shaft */}
      <rect
        x="104"
        y="60.5"
        width="52"
        height="9"
        rx="2"
        fill={colors.primary}
      />
      {/* Teeth */}
      <rect x="139" y="69" width="7" height="11" rx="2" fill={colors.primary} />
      <rect x="150" y="69" width="6" height="15" rx="2" fill={colors.primary} />
    </IllustrationSvg>
  );
}
